import type { FileUploadDesignTokens } from '@primeuix/themes/types/fileupload'

export default {
  file: {
    gap: '1rem',
    info: {
      gap: '0.5rem',
    },
    padding: '1rem',
    borderColor: '{content.border.color}',
  },
  root: {
    color: '{content.color}',
    background: '{content.background}',
    borderColor: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    transitionDuration: '{transition.duration}',
  },
  basic: {
    gap: '0.5rem',
  },
  header: {
    gap: '0.5rem',
    padding: '1.125rem',
    borderColor: '{content.border.color}',
    borderWidth: '0 0 1px 0',
    borderRadius: '5px 5px 0 0',
  },
  content: {
    gap: '1rem',
    padding: '1.125rem',
    highlightBorderColor: '{primary.color}',
  },
  fileList: {
    gap: '0.5rem',
  },
  colorScheme: {
    dark: {
      header: {
        color: '{text.color}',
        background: '{surface.800}',
      },
    },
    light: {
      header: {
        color: '{text.color}',
        background: '{surface.50}',
      },
    },
  },
  progressbar: {
    height: '0.25rem',
  },
} satisfies FileUploadDesignTokens
